import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";

function NewstellerCTA() {
  const { t } = useLanguage();

  return (
    <section className="py-16 bg-nexus-gray dark:bg-gray-900 text-white">
      <div className="container text-center">
        <h2 className="text-3xl font-bold mb-4">{t("newsletter.title")}</h2>
        <p className="text-gray-300 mb-8 max-w-2xl mx-auto">
          {t("newsletter.description")}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
          <label htmlFor="blog-newsletter-email" className="sr-only">
            {t("newsletter.emailPlaceholder")}
          </label>
          <Input
            id="blog-newsletter-email"
            type="email"
            placeholder={t("newsletter.emailPlaceholder")}
            className="flex-grow bg-white text-gray-900"
          />
          <Button className="bg-nexus-brand hover:bg-nexus-brand/90">
            {t("newsletter.subscribe")}
          </Button>
        </div>
      </div>
    </section>
  );
}

export default NewstellerCTA;
